import { Extension } from '@tiptap/core';
import {
    ZyExerciseNode,
    ZyExerciseNodeHeadless,
    ZyProblemNode,
    ZyProblemNodeHeadless,
    ZyProblemSolutionNode,
    ZyProblemSolutionNodeHeadless,
    ZySetupNode,
    ZySetupNodeHeadless,
} from './zyexercise-extension';

export const ZyExerciseHeadless = Extension.create({
    name: 'zyExerciseWrapper',

    addOptions() {
        return {};
    },

    addExtensions() {
        return [ZySetupNodeHeadless, ZyProblemNodeHeadless, ZyProblemSolutionNodeHeadless, ZyExerciseNodeHeadless];
    },
});

export const ZyExercise = ZyExerciseHeadless.extend({
    addExtensions() {
        return [ZySetupNode, ZyProblemNode, ZyProblemSolutionNode, ZyExerciseNode];
    },
});

export default ZyExercise;
